import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	theme: {

	},
};